import { render, staticRenderFns } from "./BusinessLogic.vue?vue&type=template&id=66b0d4e3&scoped=true&lang=pug"
import script from "./BusinessLogic.vue?vue&type=script&lang=js"
export * from "./BusinessLogic.vue?vue&type=script&lang=js"
import style0 from "./BusinessLogic.vue?vue&type=style&index=0&id=66b0d4e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b0d4e3",
  null
  
)

export default component.exports